/** @enum {string} */
export const Errors = {
  unknown_salesforce_org:
    'Your Salesforce organization is not registered on Max-ICS yet. Please, contact your salesforce administrator(s)'
}
